function countdownUpdate() {
    const now = new Date();
    const countDownDate = new Date("2025-05-05T22:59:59Z");
    const distance = countDownDate - now;

    const timeParts = {
        days: Math.floor(distance / (1000 * 60 * 60 * 24)),
        hours: Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
        minutes: Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)),
        seconds: Math.floor((distance % (1000 * 60)) / 1000),
    };

    const updateElements = (prefix) => {
        document.getElementById(`${prefix}-sale-days`).innerHTML = timeParts.days;
        document.getElementById(`${prefix}-sale-hours`).innerHTML = timeParts.hours;
        document.getElementById(`${prefix}-sale-minutes`).innerHTML = timeParts.minutes;
        document.getElementById(`${prefix}-sale-seconds`).innerHTML = timeParts.seconds;
    };

    if (document.getElementById("announcement-countdown")) updateElements("announcement");
    if (document.getElementById("product-countdown")) updateElements("product");
}

if (document.getElementById("announcement-countdown") || document.getElementById("product-countdown")) {
    countdownUpdate();
    setInterval(countdownUpdate, 1000);
}

function updateCounters(){
    const counters = ["page-counter-text", "cart-counter-text"];
    counters.forEach(function(counter) {
        const el = document.getElementById(counter);
        if(el) el.innerHTML = Math.floor(Math.random() * (Number(el.dataset.max) - Number(el.dataset.min) + 1)) + Number(el.dataset.min);
    });
}

function liveChatLink(){
  document.querySelectorAll('.link.animate-arrow').forEach(function(chatLink) {
    if(chatLink.getAttribute("href") == "#chat" && GorgiasChat){
      chatLink.addEventListener('click',function(){
          GorgiasChat.open();
      });
    }
  });
}

function footerNavItems(){
    const mobileNavItems = document.querySelectorAll('.footer-block__heading');
    mobileNavItems.forEach((item) => {
        item.addEventListener('click', () => {
            item.querySelector('.svg-wrapper').classList.toggle('rotate');
            item.nextElementSibling.classList.toggle('open');
        });
    });
}

function initFirstTime(){

    const sessionKeysToClear = ["myWhitesCredit", "myWhitesReferralLink", "myWhitesTier", "myWhitesOrderCount"];
    sessionKeysToClear.forEach((key) => sessionStorage.removeItem(key));

    const pathname = window.location.pathname;
    const params = new Proxy(new URLSearchParams(window.location.search), {
        get: (searchParams, prop) => searchParams.get(prop),
    });

    function populateField(id, value) {
        const field = document.getElementById(id);
        if (field && value) {
            field.value = value;
        }
        return field;
    }

    if (pathname === "/account/login" && params.email) {
        populateField('CustomerEmail', params.email);
        const passwordField = document.getElementById('CustomerPassword');
        if (passwordField) passwordField.focus();
    }

    if(pathname === "/account/register"){
        if(!sessionStorage.myWhitesSource && (params && params.whites_source)) {
            sessionStorage.myWhitesSource = params.whites_source;
        }

        if(sessionStorage.myWhitesSource){
            const tag_input = document.getElementById('RegisterForm-tags');
            tag_input.value = sessionStorage.myWhitesSource;
            tag_input.disabled = false;

            const customer_form = document.getElementById('create_customer');
            customer_form.setAttribute("data-login-with-shop-sign-up","false");
        } else {
            console.log("No customer tags found");
        }
    }

    if (pathname === "/account/register" && params.finish_account) {

        populateField('RegisterForm-FirstName', params.first_name);
        populateField('RegisterForm-LastName', params.last_name);
        populateField('RegisterForm-email', params.email);

        const accountHeader = document.getElementById('create-account-header');
        if (accountHeader) accountHeader.textContent = 'Finish creating account';

        const passwordField = document.getElementById('RegisterForm-password');
        if (passwordField) passwordField.focus();
    
    }

}

document.addEventListener('DOMContentLoaded', function() {
    updateCounters();
    liveChatLink();
    footerNavItems();
});